import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M9.155 6.11c.52 0 .945.425.945.945S9.675 8 9.155 8H6.32V6.11z" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.176 1c2.038 0 3.058 0 3.837.396a3.64 3.64 0 0 1 1.59 1.591C15 3.766 15 4.786 15 6.824v2.352c0 2.038 0 3.058-.396 3.837a3.64 3.64 0 0 1-1.591 1.59C12.234 15 11.214 15 9.176 15H6.824c-2.038 0-3.058 0-3.837-.396a3.64 3.64 0 0 1-1.59-1.591C1 12.234 1 11.214 1 9.176V6.824c0-2.038 0-3.058.396-3.837a3.64 3.64 0 0 1 1.591-1.59C3.766 1 4.786 1 6.824 1zM4.36 11.85h1.96V9.96h2.35l1.29 1.89h2.1l-1.53-2.235a2.92 2.92 0 0 0 1.53-2.56A2.905 2.905 0 0 0 9.155 4.15H4.36z"
            fill="currentColor"
        />
    </svg>
));
RabotaByAppSolidSize16Glyph.displayName = 'RabotaByAppSolidSize16Glyph';
